import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SlicePipe } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';

import { AccordionComponent } from '@shared/components';
import { SectionIds } from '@shared/models';

import { FAQService } from '../../services/FAQ.service';

@Component({
  selector: 'rp-home-faq',
  standalone: true,
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AccordionComponent, TranslateModule, SlicePipe],
  providers: [FAQService],
})
export class FaqComponent {
  readonly FAQEntites = inject(FAQService).FAQEntities;
  readonly sectionIds = SectionIds;
  readonly halfOfEntities = this.FAQEntites.length / 2;
}
